export class UndoRedo {
  constructor (vr) {
    this.vr = vr;
    this.undoStack = [];
    this.redoStack = [];

    this.init();
  }

  init () {
  }

  addToUndoStack (action) {
    this.undoStack.push(action);
  }

  addToRedoStack (action) {
    this.redoStack.push(action);
  }

  handleUndo () {
    if (this.undoStack.length > 0) {
      const undoAction = this.undoStack[0];
      this.undoRedo(this.redoStack, this.undoStack);
      this.executeAction(undoAction);
    }
  }

  handleRedo () {
    if (this.redoStack.length > 0) {
      const redoAction = this.redoStack[0];
      this.undoRedo(this.undoStack, this.redoStack);
      this.executeAction(redoAction);
    }
  }

  undoRedo (pushStack, popStack) {
    pushStack.push(popStack.shift());
  }

  executeAction (actionToExecute) {
    if (actionToExecute.action === 'boardPlacement') {
      actionToExecute.data.moveByInvoke(
        actionToExecute.x,
        actionToExecute.y,
        actionToExecute.distance);
    }
  }
}
